<template>
    <section>
        <div class="spacing-large vertical-center">
            <div>

                <h2>Option 2 Standalone with VoNR</h2>

                <p>For standalone (SA) Option 2, the 5G Core is introduced into the network, including some elements not required in Option 3X. </p>
                <p>In this alternative solution, Voice over New Radio (VoNR) uses IMS-based voice functionality. This enables users to experience simultaneous voice and high-speed 5G data. The approach is the same as that used today to provide a VoLTE service with IMS.</p>
                <p>This is the target solution, but it requires comprehensive 5G coverage to avoid frequent handovers. With VoNR, the device can attach and receive full voice and data services natively on the 5G radio.</p>
                <p>Network coverage is no longer restricted to LTE service areas, as is the case with Option 3X. However, LTE coverage remains important because the 5G radio running at higher frequencies will have a shorter range.</p>

            </div>
        </div>
        <div class="spacing-small center gray">

            <img src="~@/assets/images/chapter-3/architectural-evolution-5.png" alt="">

        </div>
    </section>
</template>

<script>

    import globalMixin from '@/mixins/globalMixin.js';

    export default {
        mixins: [globalMixin],
    }

</script>

<style lang="scss" scoped>

    .info-wrapper {
        margin: 20px 0 0;
    }

    .vertical-center {
        display: flex;
        align-items: center;
    }

</style>